import { render, staticRenderFns } from "./BedrockGuardrailForm.vue?vue&type=template&id=5c59e1ab&scoped=true&"
import script from "./BedrockGuardrailForm.vue?vue&type=script&lang=js&"
export * from "./BedrockGuardrailForm.vue?vue&type=script&lang=js&"
import style0 from "./BedrockGuardrailForm.vue?vue&type=style&index=0&id=5c59e1ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c59e1ab",
  null
  
)

export default component.exports